import React from 'react';
import PropTypes from 'prop-types';

import PaymentPresenter from '../../../../../../../../../presenters/Membership/PaymentPresenter';

const PaymentCell = (props) => {
  const { payment, onDeleteDialogOpen } = props;

  return (
    <tr>
      <td className="cell">{PaymentPresenter.amountReadable(payment)}</td>
      <td className="cell">{PaymentPresenter.state(payment)}</td>
      <td className="cell">{PaymentPresenter.typeReadable(payment)}</td>
      <td className="cell">{PaymentPresenter.createdAtReadable(payment)}</td>
      <td className="button-cell">
        <div
          id="deletePayment"
          className="action-button"
          onClick={onDeleteDialogOpen(payment)}
        >
          Delete
        </div>
      </td>
    </tr>
  );
};

export default PaymentCell;

PaymentCell.propTypes = {
  payment: PaymentPresenter.shape().isRequired,
  onDeleteDialogOpen: PropTypes.func.isRequired,
};
